<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    text: String,
    enable: Boolean,
    realnameIsFull: Boolean
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['getPreorderCommitStatus'])
  },
  methods: {
    confirm() {
      if (!this.realnameIsFull) {
        return
      }
      const ok = this.getPreorderCommitStatus
      if (!ok) {
        return
      }
      this.$emit('handleConfirm')
    }
  },
  mounted() {}
}
</script>
<template>
  <div :class="getPreorderCommitStatus ? 'confirm-btn' : 'confirm-btn disable'" @click="confirm">
    <span :style="{ opacity: realnameIsFull || !getPreorderCommitStatus ? '1' : '0.3' }">{{ text }}</span>
  </div>
</template>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';

.confirm-btn {
  height: 45px;
  width: 100%;
  font-size: 15px;
  line-height: 21px;
  padding: 14px 0;
  text-align: center;
  background-color: @orange;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  color: rgb(255, 255, 255);
  z-index: 2;
}
.disable {
  color: rgba(255, 255, 255, 0.3);
}
</style>
